import classes from "./Login.module.css";
import blueLogo from "../../images/blueLogo.svg";
import { login } from "../../redux/auth/thunks/userThunk";
import { ActionBtn } from "../../components/buttons/actionBtn/ActionBtn";
import { LoadingSpinner } from "../../components/loadingSpinner/LoadingSpinner";
import { BaseLoginInput } from "../../components/UI/baseLoginInput/BaseLoginInput";
import { resetLoginState } from "../../redux/auth/slices/userSlice";
import { useTranslations } from "../../helperFunctions/customHooks/useTranslations";
import { LanguageSwitcher } from "../../components/languageSwitcher/LanguageSwitcher";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslations();

  const userSelector = useSelector((state) => state.user);

  // Function for login form1
  useEffect(() => {
    if (userSelector.status === "success") {
      navigate("/dashboard");
    } else if (userSelector.status === "error") {
      setTimeout(() => {
        dispatch(resetLoginState());
      }, 2500);
    }
  }, [userSelector.status, navigate]);

  // Function for logging in
  const handleSubmit = (e) => {
    e.preventDefault();
    if (userSelector.status === "idle" || userSelector.status === "error") {
      dispatch(login({ email, password }));
    }
  };

  const isStatusLoading = userSelector.status === "loading";
  const isStatusError = userSelector.status === "error";
  const isBtnDisabled = isStatusLoading || email === "" || password === "";
  const loginPage = t.loginPage;

  return (
    <section className={`${classes.loginContainer} fadeIn`}>
      <div className={classes.logo}>
        <div className={classes.box}></div>
        <div className={classes.overlay}></div>
      </div>
      <div className={classes.languageSwitcherContainer}>
        <LanguageSwitcher />
      </div>

      <form className={classes.loginForm} onSubmit={handleSubmit}>
        <h2>
          <img src={blueLogo} alt="" />
        </h2>
        <div className={classes.inputs}>
          <BaseLoginInput
            label={loginPage.form.email}
            type={"text"}
            name={"email"}
            value={email}
            onChange={(e) => setEmail(e.target.value.trim())}
          />
          <BaseLoginInput
            label={loginPage.form.password}
            type={"password"}
            name={"password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <Link className={classes.forgotPass} to={"/forgot-password"}>
          <span>{loginPage.forgotPassBtn}</span>
        </Link>

        <div style={{ marginTop: "2rem" }}>
          <ActionBtn
            width={"400px"}
            height={"50px"}
            type="submit"
            disabled={isBtnDisabled}
            text={
              isStatusLoading ? (
                <LoadingSpinner black={false} />
              ) : (
                loginPage.loginBtn
              )
            }
          />
        </div>

        <div
          className={classes.errorMsg}
          style={{
            opacity: isStatusError ? 1 : 0,
            pointerEvents: isStatusError ? "auto" : "none",
          }}
        >
          {userSelector.error}
        </div>
      </form>
    </section>
  );
}
